import styled from "styled-components";

export const LoaderContainer = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0,0,0,0.4);
    z-index: 9999;

    svg {
        width: 60px;
        height: 60px;
    }
`;
